<template>
  <div class="about">
    <main class="container">
      <section class="hero">
        <img src="@/assets/arial-view.png" alt="" />
      </section>
      <section class="content">
        <div class="about-us">
          <h1>About Us</h1>
          <h2>Our Story</h2>
          <p class="text-content1">
            Caby is an initiative created to solve the problems of uncomfortable
            transportation and bring more comfortable and pleasurable ways to
            ride for the unequal populations of riders without private cars.  We
            strive to create a sustainable world class mobility service in
            Nigeria and across Africa.  We seek forward and smart thinking
            individuals with integrity and hopes for better humanity to partner
            with us in order to change the narrative of end-to-end
            transportation in Africa's harsh environments.  We believe that if
            people change their perspective and make better choices, Our cities
            and  countries will change positively and grow much better.
          </p>
          <h2 class="values">Our Values</h2>
          <p class="text-content1">
            INDEPENDENT AND BETTER CHOICES FOR PEOPLE <br>
             Our core belief is that "
            When people are better, Our cities will be better". Our mission is
            to create a sustainable alternative for people to make better
            choices of transportation for comfort, safety and convenience. By
            leveraging technology, we strive to create the freedom for people
            without private cars to enjoy seamless and comfortable rides to
            their destinations, avoiding the effects of weather on their
          </p>
        </div>
        <div class="downloads">
          <span><img src="@/assets/googlestore.png" alt="" /></span>
          <span><img src="@/assets/appstore.png" alt="" /></span>
        </div>
      </section>
    </main>
  </div>
</template>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Commissioner:wght@100;300;400&display=swap");
* {
  margin: 0;
  padding: 0;
  font-family: "Commissioner", sans-serif;
}
.container {
  margin-top: 72px;
}
.hero {
  width: 100%;
  height: 500px;
}
.hero img {
  width: 100%;
  height: 100%;
}
.content {
  min-height: 1000px;
  background-color: #ffffff;
}
.about-us {
  color: #3b3538;
  width: 50%;
  /* border: 1px solid red; */
  margin: auto;
  padding: 50px 0px;
}
.about-us h1 {
  font-size: 2.5rem;
  margin: 20px 0;
}
.text-content1 {
  margin-top: 50px;
  font-weight: 600;
  max-width: 700px;
  font-size: 18px;
  line-height: 1.8;
}
.values{
  margin-top:30px;
}
/* .text-content2 {
  font-size: 18px;
  margin-top: 50px;
  font-weight: 400;
  line-height: 1.6;
  max-width: 650px;
}
.letter-spacing {
  letter-spacing: 2px;
} */
.join {
  font-weight: 300;
  margin-top: 50px;
  font-size: 2rem;
}
.downloads {
  display: flex;
  justify-content: flex-start;
  width: 50%;
  /* border: 1px solid red; */
  margin: auto;
}
.downloads span {
  margin-top: 20px;
}
.downloads span:nth-child(2) {
  margin-left: 10%;
}
@media screen and (max-width: 1024px) {
  .about-us {
    width: 70%;
  }
  .join {
    font-size: 1.5rem;
  }
  .downloads {
    width: 70%;
    padding-bottom:30px;
  }
  .downloads span img {
    width: 200px;
  }
}
@media screen and (max-width: 768px) {
  .hero {
    height: 400px;
  }
  .about-us {
    width: 90%;
  }
  .about-us h1 {
    margin-top: 10px;
  }
  .text-content1,
  .text-content2 {
    margin-top: 30px;
  }
  .join {
    font-size: 1.3rem;
  }
  .downloads {
    flex-direction: column;
    align-items: center;
    padding-bottom: 30px;
  }
  .downloads span:nth-child(2) {
    margin-left: 0%;
  } 
  .downloads span img {
    width: 300px;
    height: 100px;
  }
}
</style>
